<template>
  <div class="history-skeleton" aria-hidden="true">
    <div
        class="history-skeleton__item"
        v-for="n in count"
        :key="`history-skeleton-${n}`"
    >
      <div class="history-skeleton__icon"></div>
      <div class="history-skeleton__info">
        <div class="history-skeleton__line history-skeleton__line--title"></div>
        <div class="history-skeleton__line history-skeleton__line--date"></div>
      </div>
      <div class="history-skeleton__price"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget-history-skeleton',
  props: {
    count: {
      type: Number,
      default: 4
    }
  }
}
</script>

<style scoped>
.history-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history-skeleton__item {
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 0 16px rgba(41, 48, 67, 0.15);
  padding: 16px 24px;
  display: grid;
  grid-template-columns: max-content 1fr 200px;
  align-items: center;
  gap: 16px;
}

.history-skeleton__icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eef3f7;
}

.history-skeleton__info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.history-skeleton__line {
  height: 14px;
  border-radius: 8px;
  background: #eef3f7;
}

.history-skeleton__line--title {
  width: 60%;
}

.history-skeleton__line--date {
  width: 35%;
}

.history-skeleton__price {
  height: 28px;
  border-radius: 12px;
  background: #eef3f7;
}

.history-skeleton__icon,
.history-skeleton__line,
.history-skeleton__price {
  position: relative;
  overflow: hidden;
}

.history-skeleton__icon::after,
.history-skeleton__line::after,
.history-skeleton__price::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%);
  animation: shimmer 1.6s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>